import type React from 'react';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { cn } from '@/app/utils';
import { SLIDER_STYLES } from '../constants';
import type { SliderThumbProps } from '../types';

export const SliderThumb: React.FC<SliderThumbProps> = ({
  position,
  thumbIndex,
  isDragging,
  disabled,
  value,
  showTooltip = false,
  tooltipFormatter = (val) => val.toString(),
  tooltipSide = 'top',
  onMouseDown,
  onTouchStart,
}) => {
  const thumbClassName = cn(
    SLIDER_STYLES.thumb.base,
    isDragging === thumbIndex && SLIDER_STYLES.thumb.dragging,
    disabled && SLIDER_STYLES.thumb.disabled,
  );

  const thumbStyle = {
    left: `${position}%`,
    transform: 'translateX(-50%)',
    zIndex: isDragging === thumbIndex ? 31 : 30,
    // 直接设置更大的宽度作为点击区域
    width: '24px', // 覆盖CSS中的5px宽度
    // 使用背景定位确保图片在中心显示
    backgroundSize: '5px 100%', // 背景图片保持5px宽度
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  const thumbElement = (
    <div
      className={thumbClassName}
      style={thumbStyle}
      onMouseDown={(e) => onMouseDown(thumbIndex, e)}
      onTouchStart={(e) => onTouchStart(thumbIndex, e)}
    />
  );

  if (showTooltip) {
    return (
      <CustomTooltip
        content={tooltipFormatter(value)}
        side={tooltipSide}
        sideOffset={8}
        open={isDragging === thumbIndex}
        trigger="hover"
      >
        {thumbElement}
      </CustomTooltip>
    );
  }

  return thumbElement;
};
